import { pages as chatPages } from "../views-new/chat/pages";
import { pages as companiesPages } from "../views-new/companies/pages";
import { pages as dashboardPages } from "../views-new/dashboard/pages";
import { pages as notificationsPages } from "../views-new/notifications/pages";
import { pages as adminInvitationsPages } from "./AdminInvitations/views";
import { pages as assignmentsPages } from "./Assignments/views";
import { pages as clientPages } from "./Clients/views";
import { pages as consultantInvitationPages } from "./ConsultantInvitations/views";
import { pages as consultantProfilesPages } from "./ConsultantProfiles/views";
import { views as contractViews } from "./Contracts/views";
import { views as jobApplicationsViews } from "./job-applications/views";
import { pages as jobRequestsPages } from "./JobRequests/views";
import { pages as landingPages } from "./Landing/views";
import { pages as managerInvitationsPages } from "./ManagerInvitations/views";
import { pages as onboardingPages } from "./Onboarding/views";
import { pages as personalInvitationsPages } from "./PersonalInvitations/views";
import { pages as sessionPages } from "./Session/views";
import { pages as usersPages } from "./Settings/views";
import { pages as tasksPages } from "./Tasks/views";
import { views as timeReportsViews } from "./time-reports/views";
import { pages as workOrdersPages } from "./WorkOrders/views";

export const pages: { [key: string]: any } = {
  ...adminInvitationsPages,
  ...assignmentsPages,
  ...clientPages,
  ...companiesPages,
  ...consultantProfilesPages,
  ...consultantInvitationPages,
  ...jobRequestsPages,
  ...landingPages,
  ...managerInvitationsPages,
  ...onboardingPages,
  ...personalInvitationsPages,
  ...sessionPages,
  ...usersPages,
  ...dashboardPages,
  ...workOrdersPages,
  ...tasksPages,
  ...notificationsPages,
  ...timeReportsViews,
  ...jobApplicationsViews,
  ...chatPages,
  ...contractViews,
};
